module.exports = __webpack_public_path__ + "components/switch-units/static/preferences-white-61942681a128e5bb7582f690f438bdbf.svg";